"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComparisonColor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const d3_scale_1 = require("d3-scale");
const withParentDimensions_1 = require("../generic/withParentDimensions");
const theme_1 = require("../../theme");
const common_styled_components_1 = require("../common-styled-components");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const react_select_1 = __importDefault(require("react-select"));
const SmallSelect_1 = require("./SmallSelect");
const getComparisonColor = (i) => {
    switch (i) {
        case 0:
            return theme_1.theme.colors.grey(2);
        default:
            return theme_1.theme.colors.greenScale[i - 1] ?? "black";
    }
};
exports.getComparisonColor = getComparisonColor;
const ChartContainer = styled_components_1.default.div `
  width: 100%;
  margin-top: ${(p) => (p.noMargin ? 0 : theme_1.theme.spacing(4))};
  margin-bottom: ${(p) => (p.noMargin ? 0 : theme_1.theme.spacing(5))};
  overflow: visible;
`;
const getOption = (valueSeries) => ({
    value: valueSeries.selectorLabel,
    label: valueSeries.selectorLabel,
});
exports.default = (0, withParentDimensions_1.withParentDimensions)(({ parentDimensions: { width }, unit, valueSeries, hideDifference, maxDigits, details, }) => {
    const [selectedSeries, setSelectedSeries] = (0, react_1.useState)(valueSeries[0]);
    const finalWidth = (0, react_1.useMemo)(() => Math.min(320, width), [width]);
    const values = selectedSeries.values;
    if (width <= 0 || !values) {
        return (0, jsx_runtime_1.jsx)("div", {});
    }
    const maximumFractionDigits = maxDigits ?? 2;
    const margins = {
        top: 15,
        bottom: 0,
        left: 4,
        right: 40,
    };
    const numberValues = values.map((v) => v.value);
    const minValue = Math.min(...numberValues);
    const maxValue = Math.max(...numberValues);
    const labelWidth = maxValue.toLocaleString("en-US", { maximumFractionDigits }).length * 14;
    const rowHeight = 30;
    const contentHeight = values.length * rowHeight;
    const height = margins.top + margins.bottom + contentHeight;
    const fontSize = theme_1.theme.fontSizeNumber(-1);
    const xScale = (0, d3_scale_1.scaleLinear)()
        .domain([Math.min(minValue, 0), maxValue])
        .range([margins.left, finalWidth - margins.right - labelWidth]);
    const change = getChange(values);
    const changeString = hideDifference || change === undefined
        ? ""
        : ` ${change < 0 ? "" : "+"}${change.toFixed(1)} %`;
    const zeroLine = xScale(0);
    return ((0, jsx_runtime_1.jsxs)(ChartContainer, { noMargin: true, children: [selectedSeries.title ? ((0, jsx_runtime_1.jsxs)(common_styled_components_1.GraphTitle, { children: [selectedSeries.title, " ", unit ? `(${unit})` : "", changeString] })) : undefined, details !== undefined && (0, jsx_runtime_1.jsx)(common_styled_components_1.PSmall, { children: details }), (0, jsx_runtime_1.jsxs)("svg", { width: finalWidth, height: height, children: [(0, jsx_runtime_1.jsx)("line", { x1: zeroLine, x2: zeroLine, y1: margins.top, y2: height, stroke: theme_1.theme.colors.grey(1), strokeWidth: 1 }), values.map((v, i) => {
                        const x = xScale(v.value);
                        const y = margins.top + i * rowHeight + rowHeight / 2;
                        const color = v.color;
                        return ((0, jsx_runtime_1.jsxs)("g", { children: [(0, jsx_runtime_1.jsx)("line", { y1: y, y2: y, x1: zeroLine, x2: x, stroke: color, strokeWidth: 2, strokeLinecap: "butt" }), (0, jsx_runtime_1.jsx)("circle", { cy: y, cx: x, r: 4, fill: color, strokeWidth: 0 }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GraphLabel, { y: y + fontSize / 2, x: Math.max(x + 8, zeroLine + 8), children: v.value.toLocaleString("en-US", {
                                        maximumFractionDigits,
                                    }) })] }, v.name));
                    })] }), valueSeries.length > 1 && ((0, jsx_runtime_1.jsx)(react_select_1.default, { options: valueSeries.map(getOption), onChange: (newValue) => {
                    const newSeries = valueSeries.find((s) => s.selectorLabel === newValue?.value);
                    if (newSeries) {
                        setSelectedSeries(newSeries);
                    }
                }, value: getOption(selectedSeries), isOptionSelected: (option) => selectedSeries.selectorLabel === option.label, styles: SmallSelect_1.smallSelectStyle }))] }));
});
function getChange(values) {
    if (values.length === 2) {
        const originalValue = values[0].value;
        const comparisonValue = values[1].value;
        return ((comparisonValue - originalValue) / originalValue) * 100;
    }
    return undefined;
}
